import {useState} from 'react';
import RadioCheckboxList from '../_radio_checkbox_list';
import DigestVisibilityGroups from '../_digest_visibility_groups';
import Icon from '../_icon';

const DigestAudienceSettings = ({
  reviewRole,
  multipleDigestsEnabled,
  visibilityGroups,
  onToggleReviewRole,
  onVisibilityGroupSelected
}) => {
  const [showInfo, setShowInfo] = useState(false);
  const toggleShowInfo = () => setShowInfo(!showInfo);

  let selectedGroups;
  let isVisibilityGroupsSelected = false;
  let selectedRole = reviewRole;

  if(multipleDigestsEnabled && Array.isArray(reviewRole)) {
    isVisibilityGroupsSelected = true;
    selectedGroups = reviewRole;
    selectedRole = 'visibilityGroups';
  }
  else if(reviewRole === null) {
    selectedRole = 'consumer';
  }

  const reviewRoleOptions = [
    {value: 'admin', label: 'Admins'},
    {value: 'curator', label: 'Admins & Curators'},
    {value: 'consumer', label: 'All users'}
  ];

  if(multipleDigestsEnabled) {
    reviewRoleOptions.splice(2, 0, {value: 'visibilityGroups', label: 'Admins, Curators & Visibility Groups'});
  }

  return (
    <div>
      <div className="digest-setting-header-with-info" data-tracking-id="digest-setting-audience-label">
        <h4 className="u-pt-m"><strong>Audience</strong></h4>
        <Icon icon="info-outline" width={18} height={18} onClick={toggleShowInfo} />
      </div>
      {showInfo && (
      <div className="help-block u-mb-xs">
        Limit this <strong>Intel Digest</strong> to specific user roles. This setting affects both the scheduled email and
        access to the feature within Klue.<br />
        <br />
        The following user roles will have this feature <strong>enabled</strong> as part of their Klue experience:<br />
      </div>
      )}
      <div className="settings-review_review-options u-mb-m" data-testid="company-settings-digest-role">
        <RadioCheckboxList
          options={reviewRoleOptions}
          selectedValue={selectedRole}
          onOptionClick={onToggleReviewRole}
          keyPrefix="review-role" />
        {isVisibilityGroupsSelected
          ? <DigestVisibilityGroups
              visibilityGroups={visibilityGroups}
              selectedGroups={selectedGroups}
              onGroupsChanged={onVisibilityGroupSelected} />
          : null
        }
      </div>
    </div>
  );
};

DigestAudienceSettings.propTypes = {
  reviewRole: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  multipleDigestsEnabled: PropTypes.bool,
  visibilityGroups: PropTypes.array,
  onToggleReviewRole: PropTypes.func,
  onVisibilityGroupSelected: PropTypes.func
};

DigestAudienceSettings.defaultProps = {
  reviewRole: null,
  multipleDigestsEnabled: false,
  visibilityGroups: [],
  onToggleReviewRole() {},
  onVisibilityGroupSelected() {}
};

export default DigestAudienceSettings;
